import http from "@/http/index";
import {AxiosInstance} from "axios";

export default class Base {
    protected http: AxiosInstance;

    constructor() {
        this.http = http;
    }
}